import { useContext } from "react";
import { SubmitGroupContext } from "./SubmitGroupContext";

/**
 * Indicates whether a parent `SubmittingGroup` is currently submitting.
 * @returns True if a parent `SubmittingGroup` is loading, otherwise false.
 */
export function useSubmitting(): boolean {
  const { submitting } = useContext(SubmitGroupContext);
  return submitting;
}
